module.exports = __webpack_public_path__ + "/static/node_modules/leaflet/dist/images/marker-shadow.44a526eed258222515aa21eaffd14a96.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/leaflet/dist/images/marker-shadow.png
// module id = wkq0
// module chunks = 1